module.exports = __webpack_public_path__ + "files/0918d7eb25f68a10f206f5ca32920331.png";